module.exports = __webpack_public_path__ + "static/media/plus-button.aecc11e8.svg";